import { initExhibitorBillingAddress } from "packs/init-exhibitor-billing-address"

const REGISTRATION_FORM_CONTAINER = "#exhibitor-registration-form-container"
const COPY_DOSSIER_LINK_SELECTOR = ".registration__copy-dossier-link"
const BILLING_TOGGLE_SELECTOR = ".js-exhibitor-billing-address-toggle"

const DOSSIER_TO_STAND_FIELDS = [
  { user: "exhibitor_user_attributes_first_name", stand: "exhibitor_first_name" },
  { user: "exhibitor_user_attributes_last_name", stand: "exhibitor_last_name" },
  { user: "exhibitor_user_attributes_company", stand: "exhibitor_company" },
  { user: "exhibitor_user_attributes_role", stand: "exhibitor_role" },
  { user: "exhibitor_user_attributes_email", stand: "exhibitor_email" },
]

const normalizeFieldValue = (value) => String(value || "").trim()

const copyDossierToStand = () => {
  DOSSIER_TO_STAND_FIELDS.forEach(({ user, stand }) => {
    const from = document.getElementById(user)
    const to = document.getElementById(stand)
    if (!from || !to) return

    to.value = from.value
    to.classList.toggle("form__input--filled", normalizeFieldValue(from.value) !== "")
  })
}

let delegationBound = false

const bindCopyDossierLinkDelegation = () => {
  if (delegationBound) return
  delegationBound = true

  document.addEventListener("click", (event) => {
    const link = event.target.closest(COPY_DOSSIER_LINK_SELECTOR)
    if (!link?.closest(REGISTRATION_FORM_CONTAINER)) return
    if (link.matches(BILLING_TOGGLE_SELECTOR)) return

    event.preventDefault()
    copyDossierToStand()
  })
}

const initExhibitorRegistrationCopy = () => {
  bindCopyDossierLinkDelegation()
  initExhibitorBillingAddress()
}

export { initExhibitorRegistrationCopy, initExhibitorRegistrationCopy as copyPasteContactDetails }
